export {};

// MSAL v5 redirect bridge: detect if this page was loaded inside a popup
// by Microsoft auth. COOP headers clear window.opener, so we check the
// URL state param instead which contains the interactionType.
function isMsalPopupRedirect(): boolean {
  const hash = window.location.hash;
  if (!hash.includes('code=') || !hash.includes('state=')) return false;

  try {
    const params = new URLSearchParams(hash.substring(1));
    const state = params.get('state');
    if (!state) return false;
    const decoded = JSON.parse(atob(state));
    return decoded?.meta?.interactionType === 'popup';
  } catch {
    return false;
  }
}

if (isMsalPopupRedirect()) {
  // @ts-ignore - Vite resolves this subpath export at build time
  import('@azure/msal-browser/redirect-bridge').then(
    ({ broadcastResponseToMainFrame }: { broadcastResponseToMainFrame: () => Promise<void> }) => {
      broadcastResponseToMainFrame().catch(console.error);
    }
  );
} else {
  import('./app-init');
}
